import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/notfound.css';
import NotFoundCat from '../assets/gr/404-cat.png'; // Updated logo path


const NotFound = () => {
    return (
        <div className="notfound-container">
            <div className="notfound-content">
                <h1>Oops! Lost your way?</h1>
                <p>It seems the page you’re looking for has wandered off. Don’t worry, we’ll help you find your way back!</p>
                <div className="notfound-image">
                    <img
                        src={NotFoundCat}
                        alt="Cute lost cat illustration"
                        className="notfound-cat"
                    />
                </div>
                <Link to="/" className="notfound-button">
                    Take Me Home
                </Link>
            </div>
        </div>
    );
};

export default NotFound;